import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['all', 'item', 'submit'];

  connect() {
    this.#refreshSubmit();
  }

  // action="input->checkboxes#toggleAll"
  toggleAll({ target }) {
    for (const item of this.itemTargets) {
      item.checked = target.checked;
    }
    this.#refreshSubmit();
  }

  // action="input->checkboxes#toggleItem"
  toggleItem() {
    this.allTarget.checked = this.itemTargets.every((item) => item.checked);
    this.#refreshSubmit();
  }

  // submit target は任意。選択した対象に対して操作するボタンを持つ画面だけが使う
  // 一覧の上下など複数置かれることがあるので、すべてに反映する
  #refreshSubmit() {
    const disabled = !this.itemTargets.some((item) => item.checked);

    for (const submit of this.submitTargets) {
      submit.disabled = disabled;
    }
  }
}
